import { render, staticRenderFns } from "./SavedBar.vue?vue&type=template&id=6af96c34"
import script from "./SavedBar.vue?vue&type=script&lang=ts"
export * from "./SavedBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports